import type { ManagerialDashboardSection } from '@/types/api'
import type { FetchManagerialDashboardParams } from '@/lib/api/managerial-dashboard-admin.service'

export const DASHBOARD_SECTIONS: ManagerialDashboardSection[] = [
  'overview',
  'sales_evolution',
  'activity',
  'finance',
  'revenue_origin',
  'client_profitability',
  'campaign_performance',
  'relationship',
  'buyers',
  'products',
  'funnel',
]

export const DASHBOARD_SECTION_LABELS: Record<ManagerialDashboardSection, string> = {
  overview: 'Indicadores principais',
  sales_evolution: 'Evolução de vendas',
  activity: 'Campanhas e pedidos',
  finance: 'Financeiro e resultado',
  revenue_origin: 'Origem da receita',
  client_profitability: 'Rentabilidade por cliente',
  campaign_performance: 'Performance das campanhas',
  relationship: 'Instituições e relacionamento',
  buyers: 'Compradores e recompra',
  products: 'Produtos adicionais',
  funnel: 'Funil rastreado',
}

export type DashboardQuery = Omit<FetchManagerialDashboardParams, 'section' | 'signal'>

export function sectionQuery(
  section: ManagerialDashboardSection,
  params: DashboardQuery
): DashboardQuery {
  const filtered = ['overview', 'activity', 'revenue_origin', 'sales_evolution'].includes(
    section
  )
  return {
    audience: params.audience,
    period: filtered && section !== 'sales_evolution' ? params.period : '12m',
    status: filtered ? params.status : 'all',
    institutionId: filtered ? params.institutionId : null,
    campaignId: filtered ? params.campaignId : null,
    chartPeriod: section === 'sales_evolution' ? params.chartPeriod : '30d',
    chartFrom: section === 'sales_evolution' ? params.chartFrom : null,
    chartTo: section === 'sales_evolution' ? params.chartTo : null,
  }
}
